module.exports = __webpack_public_path__ + "img/others_01.a2a5e224.jpg";